"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var coupon_exports = {};
__export(coupon_exports, {
  Coupon: () => Coupon
});
module.exports = __toCommonJS(coupon_exports);
var Coupon;
((Coupon2) => {
  let Add;
  ((Add2) => {
    Add2.path = "coupon/add";
  })(Add = Coupon2.Add || (Coupon2.Add = {}));
  let Remove;
  ((Remove2) => {
    Remove2.path = "coupon/remove";
  })(Remove = Coupon2.Remove || (Coupon2.Remove = {}));
})(Coupon || (Coupon = {}));
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Coupon
});
